import { useCertificationsByTeamExpiredTableStore } from '../../store/myTeamTableStateStore';
import CertificationsByTeamFilters from '../filters/CertificationsByTeamFilters';
import CertificationsByTeamExpiredTable from './CertificationsByTeamExpiredTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificationsByTeamExpiredTab = () => {
  const store = useCertificationsByTeamExpiredTableStore();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CertificationsByTeamFilters, {
      store: store
    }), /*#__PURE__*/_jsx(CertificationsByTeamExpiredTable, {})]
  });
};
export default CertificationsByTeamExpiredTab;